exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rlcLogo {\n  height: 125px; }\n\n.navbar-btn {\n  height: 50px; }\n\n.browseButton {\n  color: black; }\n\n.browseButton:hover {\n  color: white;\n  background-color: #06a6d3; }\n\n.donateButton {\n  color: white;\n  background-color: #ffc837; }\n\n.donateButton:hover {\n  background-color: #cea22e;\n  color: white; }\n\n.login-or-create-button {\n  color: #4ec8ed;\n  border: solid #4ec8ed 1.75px; }\n\n.login-or-create-button:hover {\n  color: white;\n  background-color: #06a6d3;\n  border-color: #06a6d3; }\n", ""]);

// exports
